module.exports = __webpack_public_path__ + "img/icon-watch.c8e91ad7.svg";